import SearchInput from 'components/SearchInput';
import { generateTotalGroupAndTeamMsg } from 'common/utils/utils';
import { filterAllContributors } from '../../ContributorsAndTeams.service';
import { FilterButton } from 'views/root/views/home/views/pulse/components/PulseTopBar';
import { lightColorPalette } from '@linearb/linui-common';
import { Stack } from '@mui/material';
import { Body1 } from '@linearb/linui-common/typography';

const Header = ({
  setSearchTerm,
  teamMembers = [],
  teamsWithExtraData,
  totalContributors,
  totalActiveContributors,
  isTeamLicense,
  setIsNotInTeamSelected,
  isNotInTeamSelected,
  isInTeamSelected,
  setIsInTeamSelected
}) => {
  const totalGroupsAndTeamsMsg = generateTotalGroupAndTeamMsg(
    filterAllContributors(teamsWithExtraData)
  );

  return (
    <>
      {!isTeamLicense ? (
        <Stack>
          <Body1 color={lightColorPalette.lbTextSubdued}>
            <span data-cy='developers-with-teams'>{totalContributors} </span>{' '}
            total contributors, {totalActiveContributors} active
            {totalGroupsAndTeamsMsg ? ` in ${totalGroupsAndTeamsMsg}` : ''}
          </Body1>

          <Stack direction='row' gap={1} paddingY={4}>
            {/* @ts-expect-error */}
            <SearchInput
              height='2.7rem'
              width='30rem'
              onChange={setSearchTerm}
              placeholder={`Search for contributor`}
            />
            <FilterButton
              isSelected={isNotInTeamSelected}
              onClick={() => {
                if (!isNotInTeamSelected) {
                  setIsNotInTeamSelected(true);
                  setIsInTeamSelected(false);
                  return;
                }

                setIsNotInTeamSelected(false);
              }}
              color='darkRed'
              name='Not in team'
            />
            {/* @ts-expect-error */}
            <FilterButton
              isSelected={isInTeamSelected}
              onClick={() => {
                if (!isInTeamSelected) {
                  setIsInTeamSelected(true);
                  setIsNotInTeamSelected(false);
                  return;
                }

                setIsInTeamSelected(false);
              }}
              name='Contributors in a team'
            />
          </Stack>
        </Stack>
      ) : (
        <Stack
          direction='row'
          justifyContent='space-between'
          marginBottom={1}
          alignItems={'center'}
        >
          <Body1 color={lightColorPalette.lbTextSubdued} alignItems={'center'}>
            You currently have{' '}
            <span data-cy='developers-with-teams'>{teamMembers.length}</span>{' '}
            contributors active
            {totalGroupsAndTeamsMsg ? ` in ${totalGroupsAndTeamsMsg}` : ''}
          </Body1>
          {/* @ts-expect-error */}
          <SearchInput
            height='3rem'
            width='30rem'
            onChange={setSearchTerm}
            placeholder={`Search name or email`}
          />
        </Stack>
      )}
    </>
  );
};

export default Header;
